<template>
    <div class="recommend-selection-wrapper">
        <img
            :src="selectedIcon" class="recommend-selection-btn"
            @click="changeSelect"
        >
        <div class="recommend-selection-txt">
            {{ appDetail.recommend_download.note_txt }}
        </div>
    </div>
</template>

<script>
import downloadIcon1 from 'public/assets/imgs/recommend-selection-icon1.png';
import downloadIcon2 from 'public/assets/imgs/recommend-selection-icon2.png';
export default {
    props: {
        appDetail: {
            type: Object,
            default: () => {},
        },
    },
    watch: {
        isSelected: {
            handler() {
                if (this.isSelected) {
                    this.$root.sendLog('display', 'recommendBtn_display');
                };
            },
        },
    },
    computed: {
        selectedIcon() {
            return this.$root.isRecommendSelected ? downloadIcon1 : downloadIcon2;
        },
    },
    data() {
        return {
            isSelected: false,
        };
    },
    created() {
        this.isSelected = this.$root.isRecommendSelected;
    },
    methods: {
        changeSelect() {
            this.$root.isRecommendSelected = !this.$root.isRecommendSelected;
        },
    },
};
</script>

<style lang="scss" scoped>
.recommend-selection-wrapper {
    display: flex;
    align-items: center;
    margin-top: 32px;
    .recommend-selection-btn {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        margin-right: 13px;
    }
    .recommend-selection-txt {
        font-family: PingFangSC-Regular;
        font-size: 42px;
        color: #858585;
        line-height: 42px;
        font-weight: 400;
    }
}
</style>